"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegionList = exports.isPublicAccountingWithUSAddress = exports.checkIfAddressIsAmerica = exports.checkQualificationStatus = exports.AllUSRegions = exports.convertToIsoAlpha2 = exports.ConvertFromISOToCountryCodeText = exports.ConvertFromCountryTextToISOAlpha3 = exports.ConvertFromTextToISOAlpha3 = exports.ConvertFromKeyToISOAlpha3 = exports.ConvertFromISOAlpha2ToText = exports.ConvertFromISOAlpha2ToISOAlpha3 = exports.ConvertFromISOAlpha3ToText = exports.ConvertFromISOAlpha3ToISOAlpha2 = exports.resolveCountryNamesToISOAlpha3CodeWithFallbacks = exports.CheckoutCountriesTextToISOAlpha3CodeMap = exports.CheckoutCountriesFilteredListHash = exports.countriesWithStates = exports.normalizeKosovoCountry = exports.kosovoCodesToTransform = exports.CheckoutCountriesListHash = exports.COUNTRIES_LIST = exports.EEACountriesList = exports.usaStateCodeMap = exports.canadaProvinceCodeMap = void 0;
const mxp_schemas_1 = require("mxp-schemas");
const user_1 = require("../user");
exports.canadaProvinceCodeMap = new Map(Object.entries({
    AB: 'Alberta',
    BC: 'British Columbia',
    MB: 'Manitoba',
    NB: 'New Brunswick',
    NL: 'Newfoundland and Labrador',
    NS: 'Nova Scotia',
    NT: 'Northwest Territories',
    NU: 'Nunavut',
    ON: 'Ontario',
    PE: 'Prince Edward Island',
    QC: 'Quebec',
    SK: 'Saskatchewan',
    YT: 'Yukon',
}));
exports.usaStateCodeMap = new Map(Object.entries({
    AK: 'Alaska',
    AL: 'Alabama',
    AR: 'Arkansas',
    AZ: 'Arizona',
    CA: 'California',
    CNMI: 'Commonwealth of the Northern Mariana Islands',
    CO: 'Colorado',
    CT: 'Connecticut',
    DC: 'District of Columbia',
    DE: 'Delaware',
    FL: 'Florida',
    GA: 'Georgia',
    GU: 'Guam',
    HI: 'Hawaii',
    IA: 'Iowa',
    ID: 'Idaho',
    IL: 'Illinois',
    IN: 'Indiana',
    KS: 'Kansas',
    KY: 'Kentucky',
    LA: 'Louisiana',
    MA: 'Massachusetts',
    MD: 'Maryland',
    ME: 'Maine',
    MI: 'Michigan',
    MN: 'Minnesota',
    MO: 'Missouri',
    MS: 'Mississippi',
    MT: 'Montana',
    NC: 'North Carolina',
    ND: 'North Dakota',
    NE: 'Nebraska',
    NH: 'New Hampshire',
    NJ: 'New Jersey',
    NM: 'New Mexico',
    NV: 'Nevada',
    NY: 'New York',
    OH: 'Ohio',
    OK: 'Oklahoma',
    OR: 'Oregon',
    PA: 'Pennsylvania',
    PR: 'Puerto Rico',
    RI: 'Rhode Island',
    SC: 'South Carolina',
    SD: 'South Dakota',
    TN: 'Tennessee',
    TX: 'Texas',
    UT: 'Utah',
    VA: 'Virginia',
    VI: 'Virgin Islands',
    VT: 'Vermont',
    WA: 'Washington',
    WI: 'Wisconsin',
    WV: 'West Virginia',
    WY: 'Wyoming',
}));
exports.EEACountriesList = [
    'AUT',
    'BEL',
    'BGR',
    'HRV',
    'CZE',
    'CYP',
    'DNK',
    'EST',
    'FIN',
    'FRA',
    'DEU',
    'GRC',
    'HUN',
    'ISL',
    'IRL',
    'ITA',
    'LVA',
    'LIE',
    'LTU',
    'LUX',
    'MLT',
    'NLD',
    'NOR',
    'POL',
    'PRT',
    'ROU',
    'SVK',
    'SVN',
    'ESP',
    'SWE',
    'GBR',
];
exports.COUNTRIES_LIST = [
    {
        key: 'US',
        text: 'United States',
        altNames: ['United States of America'],
        value: 'US',
        ISOAlpha3Code: 'USA',
        territory: '70000001',
        countryCode: '1',
        validateZipCode: true,
        isAmerica: true,
        tier: mxp_schemas_1.Checkout.Tiers.TIER1,
        region: 'America',
    },
    {
        key: 'GB',
        text: 'United Kingdom',
        value: 'GB',
        ISOAlpha3Code: 'GBR',
        territory: '20000601',
        countryCode: '44',
        tier: mxp_schemas_1.Checkout.Tiers.TIER1,
        region: 'Europe',
    },
    {
        key: 'CA',
        text: 'Canada',
        value: 'CA',
        ISOAlpha3Code: 'CAN',
        territory: '70000002',
        countryCode: '1*',
        isAmerica: true,
        tier: mxp_schemas_1.Checkout.Tiers.TIER1,
        region: 'America',
    },
    {
        key: 'AX',
        text: 'Aland Islands',
        value: 'AX',
        countryCode: '358',
        ISOAlpha3Code: 'ALA',
        territory: '20000629',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_13,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_13,
        region: 'Europe',
    },
    {
        key: 'AL',
        text: 'Albania',
        value: 'AL',
        countryCode: '355',
        ISOAlpha3Code: 'ALB',
        territory: '20000203',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_5,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_5,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'Europe',
    },
    {
        key: 'DZ',
        text: 'Algeria',
        value: 'DZ',
        countryCode: '213',
        ISOAlpha3Code: 'DZA',
        territory: '40000206',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_10,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_10,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'Africa',
    },
    {
        key: 'AS',
        text: 'American Samoa',
        value: 'AS',
        countryCode: '1-684',
        ISOAlpha3Code: 'ASM',
        territory: '70000001',
        isUsTerritory: true,
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_US_TERRITORIES_1,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_US_TERRITORIES_1,
        tier: mxp_schemas_1.Checkout.Tiers.TIER1,
        region: 'APAC',
        isAmerica: true,
    },
    {
        key: 'AD',
        text: 'Andorra',
        value: 'AD',
        countryCode: '376',
        ISOAlpha3Code: 'AND',
        territory: '20000204',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_10,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_10,
        tier: mxp_schemas_1.Checkout.Tiers.TIER1,
        region: 'Europe',
    },
    {
        key: 'AO',
        text: 'Angola',
        value: 'AO',
        ISOAlpha3Code: 'AGO',
        territory: '30000101',
        countryCode: '244',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_8,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_8,
        tier: mxp_schemas_1.Checkout.Tiers.TIER3,
        region: 'Africa',
    },
    {
        key: 'AI',
        text: 'Anguilla',
        value: 'AI',
        ISOAlpha3Code: 'AIA',
        territory: '70000060',
        countryCode: '1-264',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_11,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_11,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'America',
        isAmerica: true,
    },
    {
        key: 'AQ',
        text: 'Antarctica',
        ISOAlpha3Code: 'ATA',
        value: 'AQ',
        countryCode: '672',
    },
    {
        key: 'AG',
        text: 'Antigua and Barbuda',
        value: 'AG',
        countryCode: '1-268',
        ISOAlpha3Code: 'ATG',
        territory: '70000006',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_3,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_3,
        isAmerica: true,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'America',
    },
    {
        key: 'AR',
        text: 'Argentina',
        value: 'AR',
        countryCode: '54',
        ISOAlpha3Code: 'ARG',
        territory: '70000007',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_3,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_3,
        isAmerica: true,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'America',
    },
    {
        key: 'AM',
        text: 'Armenia',
        value: 'AM',
        countryCode: '374',
        ISOAlpha3Code: 'ARM',
        territory: '20000403',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_9,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_9,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
    },
    {
        key: 'AW',
        text: 'Aruba',
        value: 'AW',
        countryCode: '297',
        ISOAlpha3Code: 'ABW',
        territory: '70000008',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_1,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_1,
        region: 'America',
        isAmerica: true,
    },
    {
        key: 'AU',
        text: 'Australia',
        value: 'AU',
        ISOAlpha3Code: 'AUS',
        territory: '50000101',
        countryCode: '61',
        tier: mxp_schemas_1.Checkout.Tiers.TIER1,
        region: 'APAC',
    },
    {
        key: 'AT',
        text: 'Austria',
        value: 'AT',
        ISOAlpha3Code: 'AUT',
        territory: '20000205',
        countryCode: '43',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        tier: mxp_schemas_1.Checkout.Tiers.TIER1,
        region: 'Europe',
    },
    {
        key: 'AZ',
        text: 'Azerbaijan',
        value: 'AZ',
        ISOAlpha3Code: 'AZE',
        territory: '20000404',
        countryCode: '994',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
    },
    {
        key: 'BS',
        text: 'Bahamas',
        value: 'BS',
        ISOAlpha3Code: 'BHS',
        territory: '70000003',
        countryCode: '1-242',
        isAmerica: true,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'America',
    },
    {
        key: 'BH',
        text: 'Bahrain',
        value: 'BH',
        ISOAlpha3Code: 'BHR',
        territory: '40000401',
        countryCode: '973',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
    },
    {
        key: 'BD',
        text: 'Bangladesh',
        value: 'BD',
        ISOAlpha3Code: 'BGD',
        territory: '40000101',
        countryCode: '880',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
    },
    {
        key: 'BB',
        text: 'Barbados',
        value: 'BB',
        countryCode: '1-246',
        ISOAlpha3Code: 'BRB',
        territory: '70000010',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_1,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_1,
        isAmerica: true,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'America',
    },
    {
        key: 'BE',
        text: 'Belgium',
        value: 'BE',
        ISOAlpha3Code: 'BEL',
        territory: '20000207',
        countryCode: '32',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        tier: mxp_schemas_1.Checkout.Tiers.TIER1,
        region: 'Europe',
    },
    {
        key: 'BZ',
        text: 'Belize',
        value: 'BZ',
        countryCode: '501',
        ISOAlpha3Code: 'BLZ',
        territory: '70000011',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_3,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_3,
        isAmerica: true,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'America',
    },
    {
        key: 'BJ',
        text: 'Benin',
        value: 'BJ',
        countryCode: '229',
        ISOAlpha3Code: 'BEN',
        territory: '30001302',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_1,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_1,
        tier: mxp_schemas_1.Checkout.Tiers.TIER3,
        region: 'Africa',
    },
    {
        key: 'BM',
        text: 'Bermuda',
        value: 'BM',
        ISOAlpha3Code: 'BMU',
        territory: '70000004',
        countryCode: '1-441',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'America',
        isAmerica: true,
    },
    {
        key: 'BT',
        text: 'Bhutan',
        value: 'BT',
        countryCode: '975',
        ISOAlpha3Code: 'BTN',
        territory: '40000207',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_14,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_14,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
    },
    {
        key: 'BO',
        text: 'Bolivia',
        value: 'BO',
        countryCode: '591',
        isAmerica: true,
        ISOAlpha3Code: 'BOL',
        territory: '70000013',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_12,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_12,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'America',
    },
    {
        key: 'BQ',
        text: 'Bonaire, Sint Eustatius and Saba',
        value: 'BQ',
        countryCode: '599',
        ISOAlpha3Code: 'BES',
        territory: '70000063',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_16,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_16,
    },
    {
        key: 'BA',
        text: 'Bosnia and Herzegovina',
        value: 'BA',
        ISOAlpha3Code: 'BIH',
        territory: '20000208',
        countryCode: '387',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CountriesFeatureToggleConstants.BLOCKED,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_BOSNIA_HERZEGOVINA,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'Europe',
    },
    {
        key: 'BW',
        text: 'Botswana',
        value: 'BW',
        ISOAlpha3Code: 'BWA',
        territory: '30000201',
        countryCode: '267',
        tier: mxp_schemas_1.Checkout.Tiers.TIER3,
        region: 'Africa',
    },
    {
        key: 'BV',
        ISOAlpha3Code: 'BVT',
        text: 'Bouvet Island',
        value: 'BV',
        countryCode: '47',
    },
    {
        key: 'BR',
        text: 'Brazil',
        value: 'BR',
        ISOAlpha3Code: 'BRA',
        territory: '70000015',
        countryCode: '55',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_PART_2_ADDITIONAL_COUNTRIES,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_PART_2_ADDITIONAL_COUNTRIES,
        isAmerica: true,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'America',
    },
    {
        key: 'IO',
        text: 'British Indian Ocean Territory',
        value: 'IO',
        countryCode: '246',
        ISOAlpha3Code: 'IOT',
        territory: '50003008',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_14,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_14,
        region: 'APAC',
    },
    {
        key: 'BN',
        text: 'Brunei',
        value: 'BN',
        ISOAlpha3Code: 'BRN',
        territory: '40000223',
        countryCode: '673',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_8,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_8,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
    },
    {
        key: 'BG',
        text: 'Bulgaria',
        value: 'BG',
        ISOAlpha3Code: 'BGR',
        territory: '20000505',
        countryCode: '359',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'Europe',
    },
    {
        key: 'BF',
        text: 'Burkina Faso',
        value: 'BF',
        countryCode: '226',
        ISOAlpha3Code: 'BFA',
        territory: '30001304',
        validateZipCode: false,
        minPrecision: mxp_schemas_1.SmartyStreets.PrecisionLevel.NONE,
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_15,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_15,
        tier: mxp_schemas_1.Checkout.Tiers.TIER3,
        region: 'Africa',
    },
    {
        key: 'BI',
        ISOAlpha3Code: 'BDI',
        text: 'Burundi',
        value: 'BI',
        countryCode: '257',
        territory: '30001305',
        tier: mxp_schemas_1.Checkout.Tiers.TIER3,
        region: 'Africa',
    },
    {
        key: 'KH',
        text: 'Cambodia',
        value: 'KH',
        ISOAlpha3Code: 'KHM',
        territory: '50000011',
        countryCode: '855',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
    },
    {
        key: 'CM',
        text: 'Cameroon',
        value: 'CM',
        countryCode: '237',
        ISOAlpha3Code: 'CMR',
        territory: '30001306',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_4,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_4,
        tier: mxp_schemas_1.Checkout.Tiers.TIER3,
        region: 'Africa',
    },
    {
        key: 'CV',
        text: 'Cape Verde',
        value: 'CV',
        countryCode: '238',
        ISOAlpha3Code: 'CPV',
        territory: '30001307',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_12,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_12,
        tier: mxp_schemas_1.Checkout.Tiers.TIER3,
        region: 'Africa',
    },
    {
        key: 'KY',
        text: 'Cayman Islands',
        value: 'KY',
        ISOAlpha3Code: 'CYM',
        territory: '70000003',
        countryCode: '1-345',
        tier: mxp_schemas_1.Checkout.Tiers.TIER1,
        region: 'America',
        isAmerica: true,
    },
    {
        key: 'CF',
        text: 'Central African Republic',
        ISOAlpha3Code: 'CAF',
        value: 'CF',
        countryCode: '236',
        territory: '30001308',
        tier: mxp_schemas_1.Checkout.Tiers.TIER3,
        region: 'Africa',
    },
    {
        key: 'TD',
        text: 'Chad',
        value: 'TD',
        countryCode: '235',
        ISOAlpha3Code: 'TCD',
        territory: '30001309',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_10,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_10,
        tier: mxp_schemas_1.Checkout.Tiers.TIER3,
        region: 'Africa',
    },
    {
        key: 'CL',
        text: 'Chile',
        value: 'CL',
        countryCode: '56',
        ISOAlpha3Code: 'CHL',
        territory: '70000017',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_1,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_1,
        isAmerica: true,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'America',
    },
    {
        key: 'CN',
        text: 'China',
        value: 'CN',
        ISOAlpha3Code: 'CHN',
        territory: '60030101',
        countryCode: '86',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_PART_2_ADDITIONAL_COUNTRIES,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_PART_2_ADDITIONAL_COUNTRIES,
        tier: mxp_schemas_1.Checkout.Tiers.TIER1,
        region: 'APAC',
    },
    {
        key: 'CX',
        text: 'Christmas Island',
        value: 'CX',
        countryCode: '61',
        ISOAlpha3Code: 'CXR',
        territory: '50003001',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_13,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_13,
        region: 'APAC',
    },
    {
        key: 'CC',
        text: 'Cocos (Keeling) Islands',
        value: 'CC',
        countryCode: '61',
        ISOAlpha3Code: 'CCK',
        territory: '50003002',
        validateZipCode: false,
        minPrecision: mxp_schemas_1.SmartyStreets.PrecisionLevel.NONE,
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_15,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_15,
        region: 'APAC',
    },
    {
        key: 'CO',
        text: 'Colombia',
        value: 'CO',
        countryCode: '57',
        ISOAlpha3Code: 'COL',
        territory: '70000018',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CountriesFeatureToggleConstants.BLOCKED,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_COLOMBIA,
        isAmerica: true,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'America',
    },
    {
        key: 'KM',
        text: 'Comoros',
        value: 'KM',
        countryCode: '269',
        ISOAlpha3Code: 'COM',
        territory: '30001310',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_13,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_13,
        region: 'Africa',
    },
    {
        key: 'CG',
        text: 'Congo',
        value: 'CG',
        countryCode: '242',
        ISOAlpha3Code: 'COG',
        territory: '30001312',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_14,
        tier: mxp_schemas_1.Checkout.Tiers.TIER3,
        region: 'Africa',
    },
    {
        key: 'CD',
        text: 'Congo, the Democratic Republic of the',
        altNames: ['Congo. Democratic Republic of the'],
        value: 'CD',
        countryCode: '243',
        ISOAlpha3Code: 'COD',
        territory: '30001312',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_CIMA_VERY_HIGH_RISK_B2C,
        tier: mxp_schemas_1.Checkout.Tiers.TIER3,
        region: 'AfricaAfrica',
    },
    {
        key: 'CK',
        text: 'Cook Islands',
        value: 'CK',
        countryCode: '682',
        ISOAlpha3Code: 'COK',
        territory: '50003009',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_14,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_14,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
    },
    {
        key: 'CR',
        text: 'Costa Rica',
        value: 'CR',
        countryCode: '506',
        ISOAlpha3Code: 'CRI',
        territory: '70000019',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_5,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_5,
        isAmerica: true,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'America',
    },
    {
        key: 'CI',
        text: "Cote D'Ivoire",
        altNames: ["Côte d'Ivoire"],
        value: 'CI',
        countryCode: '225',
        ISOAlpha3Code: 'CIV',
        territory: '30001313',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_5,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_5,
        tier: mxp_schemas_1.Checkout.Tiers.TIER3,
        region: 'Africa',
    },
    {
        key: 'HR',
        text: 'Croatia',
        value: 'HR',
        countryCode: '385',
        ISOAlpha3Code: 'HRV',
        territory: '20000209',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_9,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_9,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'Europe',
    },
    {
        key: 'CW',
        text: 'Curacao',
        altNames: ['Curaçao'],
        value: 'CW',
        ISOAlpha3Code: 'CUW',
        territory: '70000005',
        countryCode: '599',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        region: 'Europe',
        isAmerica: true,
    },
    {
        key: 'CY',
        text: 'Cyprus',
        value: 'CY',
        countryCode: '357',
        ISOAlpha3Code: 'CYP',
        territory: '20000210',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_3,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_3,
        tier: mxp_schemas_1.Checkout.Tiers.TIER1,
        region: 'Europe',
    },
    {
        key: 'CZ',
        text: 'Czech Republic',
        value: 'CZ',
        ISOAlpha3Code: 'CZE',
        territory: '20000506',
        reformatZipcode: true,
        countryCode: '420',
        allowAliasChange: true,
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_CZECH_REPUBLIC,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_CZECH_REPUBLIC,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'Europe',
    },
    {
        key: 'DK',
        text: 'Denmark',
        value: 'DK',
        countryCode: '45',
        ISOAlpha3Code: 'DNK',
        territory: '20000211',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_1,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_1,
        tier: mxp_schemas_1.Checkout.Tiers.TIER1,
        region: 'Europe',
    },
    {
        key: 'DJ',
        text: 'Djibouti',
        value: 'DJ',
        countryCode: '253',
        ISOAlpha3Code: 'DJI',
        territory: '30001314',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_12,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_12,
        tier: mxp_schemas_1.Checkout.Tiers.TIER3,
        region: 'Africa',
    },
    {
        key: 'DM',
        text: 'Dominica',
        value: 'DM',
        countryCode: '1-767',
        isAmerica: true,
        ISOAlpha3Code: 'DMA',
        territory: '70000022',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_14,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_14,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'America',
    },
    {
        key: 'DO',
        text: 'Dominican Republic',
        value: 'DO',
        countryCode: '1-809',
        ISOAlpha3Code: 'DOM',
        territory: '70000023',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_4,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_4,
        isAmerica: true,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'America',
    },
    {
        key: 'EC',
        text: 'Ecuador',
        value: 'EC',
        countryCode: '593',
        ISOAlpha3Code: 'ECU',
        territory: '70000024',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_4,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_4,
        isAmerica: true,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'America',
    },
    {
        key: 'EG',
        text: 'Egypt',
        value: 'EG',
        ISOAlpha3Code: 'EGY',
        territory: '40000203',
        countryCode: '20',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'Africa',
    },
    {
        key: 'SV',
        text: 'El Salvador',
        value: 'SV',
        countryCode: '503',
        ISOAlpha3Code: 'SLV',
        territory: '70000025',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_6,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_6,
        isAmerica: true,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'America',
    },
    {
        key: 'GQ',
        text: 'Equatorial Guinea',
        value: 'GQ',
        countryCode: '240',
        ISOAlpha3Code: 'GNQ',
        territory: '30001315',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_13,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_13,
        tier: mxp_schemas_1.Checkout.Tiers.TIER3,
        region: 'Africa',
    },
    {
        key: 'ER',
        text: 'Eritrea',
        value: 'ER',
        countryCode: '291',
        ISOAlpha3Code: 'ERI',
        territory: '30001316',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_13,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_13,
        tier: mxp_schemas_1.Checkout.Tiers.TIER3,
        region: 'Africa',
    },
    {
        key: 'EE',
        text: 'Estonia',
        value: 'EE',
        countryCode: '372',
        ISOAlpha3Code: 'EST',
        territory: '20000212',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_10,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_10,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'Europe',
    },
    {
        key: 'SZ',
        text: 'Eswatini (formerly Swaziland)',
        value: 'SZ',
        ISOAlpha3Code: 'SWZ',
        territory: '30001344',
        countryCode: '268',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_14,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_14,
        tier: mxp_schemas_1.Checkout.Tiers.TIER3,
        region: 'Africa',
    },
    {
        key: 'ET',
        text: 'Ethiopia',
        value: 'ET',
        countryCode: '251',
        ISOAlpha3Code: 'ETH',
        territory: '30001317',
        minPrecision: mxp_schemas_1.SmartyStreets.PrecisionLevel.LOCALITY,
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_AICPA_VERY_HIGH_RISK_APPROVED_B2C,
        tier: mxp_schemas_1.Checkout.Tiers.TIER3,
        region: 'Africa',
    },
    {
        key: 'FK',
        text: 'Falkland Islands',
        value: 'FK',
        countryCode: '500',
        ISOAlpha3Code: 'FLK',
        territory: '70000062',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_14,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_14,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'America',
        isAmerica: true,
    },
    {
        key: 'FO',
        text: 'Faroe Islands',
        value: 'FO',
        countryCode: '298',
        ISOAlpha3Code: 'FRO',
        territory: '20000626',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_13,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_13,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'Europe',
    },
    {
        key: 'FJ',
        text: 'Fiji',
        value: 'FJ',
        countryCode: '679',
        ISOAlpha3Code: 'FJI',
        territory: '50000015',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_6,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_6,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
    },
    {
        key: 'FI',
        text: 'Finland',
        value: 'FI',
        countryCode: '358',
        ISOAlpha3Code: 'FIN',
        territory: '20000214',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_5,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_5,
        tier: mxp_schemas_1.Checkout.Tiers.TIER1,
        region: 'Europe',
    },
    {
        key: 'FR',
        text: 'France',
        value: 'FR',
        ISOAlpha3Code: 'FRA',
        territory: '20000215',
        countryCode: '33',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        tier: mxp_schemas_1.Checkout.Tiers.TIER1,
        region: 'Europe',
    },
    {
        key: 'GF',
        text: 'French Guiana',
        value: 'GF',
        countryCode: '594',
        ISOAlpha3Code: 'GUF',
        territory: '70000070',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_13,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_13,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'America',
        isAmerica: true,
    },
    {
        key: 'PF',
        text: 'French Polynesia',
        value: 'PF',
        countryCode: '689',
        ISOAlpha3Code: 'PYF',
        territory: '50003010',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_13,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_13,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
    },
    {
        key: 'TF',
        text: 'French Southern Territories',
        ISOAlpha3Code: 'ATF',
        value: 'TF',
        countryCode: '262',
        region: 'Europe',
    },
    {
        key: 'GA',
        text: 'Gabon',
        value: 'GA',
        countryCode: '241',
        ISOAlpha3Code: 'GAB',
        territory: '30001319',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_5,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_5,
        tier: mxp_schemas_1.Checkout.Tiers.TIER3,
        region: 'Africa',
    },
    {
        key: 'GM',
        text: 'Gambia',
        value: 'GM',
        countryCode: '220',
        ISOAlpha3Code: 'GMB',
        territory: '30001320',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_9,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_9,
        tier: mxp_schemas_1.Checkout.Tiers.TIER3,
        region: 'Africa',
    },
    {
        key: 'GE',
        text: 'Georgia',
        value: 'GE',
        ISOAlpha3Code: 'GEO',
        territory: '20000216',
        countryCode: '995',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
    },
    {
        key: 'DE',
        text: 'Germany',
        value: 'DE',
        ISOAlpha3Code: 'DEU',
        territory: '20000501',
        countryCode: '49',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        tier: mxp_schemas_1.Checkout.Tiers.TIER1,
        region: 'Europe',
    },
    {
        key: 'GH',
        text: 'Ghana',
        value: 'GH',
        ISOAlpha3Code: 'GHA',
        territory: '30000301',
        countryCode: '233',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        tier: mxp_schemas_1.Checkout.Tiers.TIER3,
        region: 'Africa',
    },
    {
        key: 'GI',
        text: 'Gibraltar',
        value: 'GI',
        ISOAlpha3Code: 'GIB',
        territory: '20000249',
        countryCode: '350',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_8,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_8,
        tier: mxp_schemas_1.Checkout.Tiers.TIER1,
        region: 'Europe',
    },
    {
        key: 'GR',
        text: 'Greece',
        value: 'GR',
        ISOAlpha3Code: 'GRC',
        territory: '20000217',
        countryCode: '30',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'Europe',
    },
    {
        key: 'GL',
        text: 'Greenland',
        value: 'GL',
        countryCode: '299',
        ISOAlpha3Code: 'GRL',
        territory: '20000625',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_13,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_13,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'America',
    },
    {
        key: 'GD',
        text: 'Grenada',
        value: 'GD',
        countryCode: '1-473',
        isAmerica: true,
        ISOAlpha3Code: 'GRD',
        territory: '70000028',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_14,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_14,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'America',
    },
    {
        key: 'GP',
        text: 'Guadeloupe',
        value: 'GP',
        countryCode: '590',
        ISOAlpha3Code: 'GLP',
        territory: '70000064',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_14,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_14,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
        isAmerica: true,
    },
    {
        key: 'GU',
        text: 'Guam',
        value: 'GU',
        countryCode: '1-671',
        ISOAlpha3Code: 'GUM',
        territory: '70000001',
        isUsTerritory: true,
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_US_TERRITORIES_1,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_US_TERRITORIES_1,
        tier: mxp_schemas_1.Checkout.Tiers.TIER1,
        region: 'APAC',
        isAmerica: true,
    },
    {
        key: 'GT',
        text: 'Guatemala',
        value: 'GT',
        countryCode: '502',
        ISOAlpha3Code: 'GTM',
        territory: '70000030',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_1,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_1,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        isAmerica: true,
        region: 'America',
    },
    {
        key: 'GG',
        text: 'Guernsey',
        value: 'GG',
        countryCode: '44-1481',
        ISOAlpha3Code: 'GGY',
        territory: '20000622',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_6,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_6,
        region: 'Europe',
    },
    {
        key: 'GN',
        text: 'Guinea',
        value: 'GN',
        countryCode: '224',
        ISOAlpha3Code: 'GIN',
        territory: '30001348',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_CIMA_VERY_HIGH_RISK_B2C,
        tier: mxp_schemas_1.Checkout.Tiers.TIER3,
        region: 'Africa',
    },
    {
        key: 'GW',
        text: 'Guinea-Bissau',
        value: 'GW',
        ISOAlpha3Code: 'GNB',
        countryCode: '245',
        territory: '40000610',
        tier: mxp_schemas_1.Checkout.Tiers.TIER3,
        region: 'Africa',
    },
    {
        key: 'GY',
        text: 'Guyana',
        value: 'GY',
        countryCode: '592',
        ISOAlpha3Code: 'GUY',
        territory: '70000031',
        minPrecision: mxp_schemas_1.SmartyStreets.PrecisionLevel.LOCALITY,
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_5,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_5,
        isAmerica: true,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'America',
    },
    {
        key: 'HT',
        text: 'Haiti',
        value: 'HT',
        countryCode: '509',
        ISOAlpha3Code: 'HTI',
        territory: '70000032',
        minPrecision: mxp_schemas_1.SmartyStreets.PrecisionLevel.LOCALITY,
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_5,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_5,
        isAmerica: true,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'America',
    },
    {
        key: 'HM',
        text: 'Heard and McDonald Islands',
        value: 'HM',
        ISOAlpha3Code: 'HMD',
        countryCode: '672',
        region: 'APAC',
    },
    {
        key: 'HN',
        text: 'Honduras',
        value: 'HN',
        countryCode: '504',
        ISOAlpha3Code: 'HND',
        territory: '70000033',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_5,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_5,
        isAmerica: true,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'America',
    },
    {
        key: 'HK',
        text: 'Hong Kong SAR, China',
        altNames: ['Hong Kong'],
        value: 'HK',
        ISOAlpha3Code: 'HKG',
        territory: '60020001',
        useSuperAdminArea: true,
        countryCode: '852',
        tier: mxp_schemas_1.Checkout.Tiers.TIER1,
        region: 'North Asia',
    },
    {
        key: 'HU',
        text: 'Hungary',
        value: 'HU',
        countryCode: '36',
        ISOAlpha3Code: 'HUN',
        territory: '20000507',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_6,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_6,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'Europe',
    },
    {
        key: 'IS',
        text: 'Iceland',
        value: 'IS',
        countryCode: '354',
        ISOAlpha3Code: 'ISL',
        territory: '20000220',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_1,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_1,
        tier: mxp_schemas_1.Checkout.Tiers.TIER1,
        region: 'Europe',
    },
    {
        key: 'IN',
        text: 'India',
        value: 'IN',
        ISOAlpha3Code: 'IND',
        territory: '50020001',
        countryCode: '91',
        minPrecision: mxp_schemas_1.SmartyStreets.PrecisionLevel.LOCALITY,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
    },
    {
        key: 'ID',
        text: 'Indonesia',
        value: 'ID',
        ISOAlpha3Code: 'IDN',
        territory: '50000001',
        countryCode: '62',
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
    },
    {
        key: 'IQ',
        text: 'Iraq',
        value: 'IQ',
        countryCode: '964',
        ISOAlpha3Code: 'IRQ',
        territory: '40000210',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_CIMA_VERY_HIGH_RISK_B2C,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
    },
    {
        key: 'IE',
        text: 'Ireland',
        value: 'IE',
        ISOAlpha3Code: 'IRL',
        territory: '20000102',
        countryCode: '353',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        tier: mxp_schemas_1.Checkout.Tiers.TIER1,
        region: 'Europe',
    },
    {
        key: 'IM',
        text: 'Isle of Man',
        value: 'IM',
        countryCode: '44-1624',
        ISOAlpha3Code: 'IMN',
        territory: '20000631',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_14,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_14,
        region: 'Europe',
    },
    {
        key: 'IL',
        text: 'Israel',
        value: 'IL',
        countryCode: '972',
        ISOAlpha3Code: 'ISR',
        territory: '40000211',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_1,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_1,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
    },
    {
        key: 'IT',
        text: 'Italy',
        value: 'IT',
        ISOAlpha3Code: 'ITA',
        territory: '20000221',
        countryCode: '39',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        tier: mxp_schemas_1.Checkout.Tiers.TIER1,
        region: 'Europe',
    },
    {
        key: 'JM',
        text: 'Jamaica',
        value: 'JM',
        ISOAlpha3Code: 'JAM',
        territory: '70000034',
        countryCode: '1-876',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_2,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_2,
        isAmerica: true,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'America',
    },
    {
        key: 'JP',
        text: 'Japan',
        value: 'JP',
        ISOAlpha3Code: 'JPN',
        territory: '60040001',
        countryCode: '81',
        tier: mxp_schemas_1.Checkout.Tiers.TIER1,
        region: 'APAC',
    },
    {
        key: 'JE',
        text: 'Jersey',
        value: 'JE',
        countryCode: '44-1534',
        ISOAlpha3Code: 'JEY',
        territory: '20000623',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_6,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_6,
        region: 'Europe',
    },
    {
        key: 'JO',
        text: 'Jordan',
        value: 'JO',
        ISOAlpha3Code: 'JOR',
        territory: '40000212',
        countryCode: '962',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_2,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_2,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
    },
    {
        key: 'KZ',
        text: 'Kazakhstan',
        value: 'KZ',
        ISOAlpha3Code: 'KAZ',
        territory: '20000405',
        countryCode: '7',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
    },
    {
        key: 'KE',
        text: 'Kenya',
        value: 'KE',
        ISOAlpha3Code: 'KEN',
        territory: '30000401',
        countryCode: '254',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        tier: mxp_schemas_1.Checkout.Tiers.TIER3,
        region: 'Africa',
    },
    {
        key: 'KI',
        text: 'Kiribati',
        value: 'KI',
        countryCode: '686',
        ISOAlpha3Code: 'KIR',
        territory: '50000017',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_13,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_13,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
    },
    {
        key: 'KR',
        text: 'Korea, the Republic of',
        altNames: ['Korea, Republic of'],
        value: 'KR',
        ISOAlpha3Code: 'KOR',
        territory: '60040003',
        countryCode: '82',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        tier: mxp_schemas_1.Checkout.Tiers.TIER1,
        region: 'APAC',
    },
    {
        key: 'XK',
        text: 'Kosovo',
        value: 'XK',
        ISOAlpha3Code: 'XKX',
        territory: '20000627',
        countryCode: '383',
        tier: mxp_schemas_1.Checkout.Tiers.TIER1,
        region: 'Europe',
    },
    {
        key: 'KW',
        text: 'Kuwait',
        value: 'KW',
        ISOAlpha3Code: 'KWT',
        territory: '40000402',
        countryCode: '965',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_2,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_2,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
    },
    {
        key: 'KG',
        text: 'Kyrgyzstan',
        value: 'KG',
        countryCode: '996',
        ISOAlpha3Code: 'KGZ',
        territory: '20000222',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_14,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_14,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
    },
    {
        key: 'LA',
        text: "Lao People's Democratic Republic",
        value: 'LA',
        countryCode: '856',
        ISOAlpha3Code: 'LAO',
        territory: '50000018',
        minPrecision: mxp_schemas_1.SmartyStreets.PrecisionLevel.LOCALITY,
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_7,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_7,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
    },
    {
        key: 'LV',
        text: 'Latvia',
        value: 'LV',
        ISOAlpha3Code: 'LVA',
        countryCode: '371',
        territory: '20000223',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_9,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_9,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'Europe',
    },
    {
        key: 'LB',
        text: 'Lebanon',
        value: 'LB',
        countryCode: '961',
        ISOAlpha3Code: 'LBN',
        territory: '40000214',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_AICPA_VERY_HIGH_RISK_APPROVED_B2C,
        isRestricted: true,
        tier: mxp_schemas_1.Checkout.Tiers.RESTRICTED,
        region: 'APAC',
    },
    {
        key: 'LS',
        text: 'Lesotho',
        value: 'LS',
        ISOAlpha3Code: 'LSO',
        territory: '30001324',
        countryCode: '266',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        tier: mxp_schemas_1.Checkout.Tiers.TIER3,
        region: 'Africa',
    },
    {
        key: 'LR',
        text: 'Liberia',
        value: 'LR',
        countryCode: '231',
        ISOAlpha3Code: 'LBR',
        territory: '30001325',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_4,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_4,
        tier: mxp_schemas_1.Checkout.Tiers.TIER3,
        region: 'Africa',
    },
    {
        key: 'LY',
        text: 'Libya',
        value: 'LY',
        ISOAlpha3Code: 'LBY',
        countryCode: '218',
        territory: '40000215',
        isRestricted: true,
        tier: mxp_schemas_1.Checkout.Tiers.RESTRICTED,
        region: 'Africa',
    },
    {
        key: 'LI',
        text: 'Liechtenstein',
        value: 'LI',
        countryCode: '423',
        ISOAlpha3Code: 'LIE',
        territory: '20000224',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_7,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_7,
        tier: mxp_schemas_1.Checkout.Tiers.TIER1,
        region: 'Europe',
    },
    {
        key: 'LT',
        text: 'Lithuania',
        value: 'LT',
        ISOAlpha3Code: 'LTU',
        territory: '20000225',
        countryCode: '370',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_8,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_8,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'Europe',
    },
    {
        key: 'LU',
        text: 'Luxembourg',
        value: 'LU',
        ISOAlpha3Code: 'LUX',
        territory: '20000226',
        countryCode: '352',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_2,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_2,
        tier: mxp_schemas_1.Checkout.Tiers.TIER1,
        region: 'Europe',
    },
    {
        key: 'MO',
        text: 'Macao SAR, China',
        altNames: ['Macao'],
        value: 'MO',
        ISOAlpha3Code: 'MAC',
        territory: '60020002',
        countryCode: '853',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        tier: mxp_schemas_1.Checkout.Tiers.TIER1,
        region: 'APAC',
    },
    {
        key: 'MK',
        text: 'Macedonia',
        value: 'MK',
        countryCode: '389',
        ISOAlpha3Code: 'MKD',
        territory: '20000227',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_10,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_10,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'Europe',
    },
    {
        key: 'MG',
        text: 'Madagascar',
        value: 'MG',
        countryCode: '261',
        ISOAlpha3Code: 'MDG',
        territory: '30001326',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_7,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_7,
        tier: mxp_schemas_1.Checkout.Tiers.TIER3,
        region: 'Africa',
    },
    {
        key: 'MW',
        text: 'Malawi',
        value: 'MW',
        ISOAlpha3Code: 'MWI',
        territory: '30000501',
        countryCode: '265',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        tier: mxp_schemas_1.Checkout.Tiers.TIER3,
        region: 'Africa',
    },
    {
        key: 'MY',
        text: 'Malaysia',
        value: 'MY',
        ISOAlpha3Code: 'MYS',
        territory: '50000002',
        countryCode: '60',
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
    },
    {
        key: 'MV',
        text: 'Maldives',
        value: 'MV',
        countryCode: '960',
        ISOAlpha3Code: 'MDV',
        territory: '40000201',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_6,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_6,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
    },
    {
        key: 'ML',
        text: 'Mali',
        value: 'ML',
        countryCode: '223',
        ISOAlpha3Code: 'MLI',
        territory: '30001328',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_CIMA_VERY_HIGH_RISK_B2C,
        tier: mxp_schemas_1.Checkout.Tiers.TIER3,
        region: 'Africa',
    },
    {
        key: 'MT',
        text: 'Malta',
        value: 'MT',
        ISOAlpha3Code: 'MLT',
        territory: '20000228',
        countryCode: '356',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_2,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_2,
        tier: mxp_schemas_1.Checkout.Tiers.TIER1,
        region: 'Europe',
    },
    {
        key: 'MH',
        text: 'Marshall Islands',
        value: 'MH',
        countryCode: '692',
        ISOAlpha3Code: 'MHL',
        territory: '50000019',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_16,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_16,
    },
    {
        key: 'MQ',
        text: 'Martinique',
        value: 'MQ',
        countryCode: '596',
        ISOAlpha3Code: 'MTQ',
        territory: '70000065',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_14,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_14,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
        isAmerica: true,
    },
    {
        key: 'MR',
        text: 'Mauritania',
        value: 'MR',
        countryCode: '222',
        ISOAlpha3Code: 'MRT',
        territory: '30001329',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_12,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_12,
        tier: mxp_schemas_1.Checkout.Tiers.TIER3,
        region: 'Africa',
    },
    {
        key: 'MU',
        text: 'Mauritius',
        value: 'MU',
        ISOAlpha3Code: 'MUS',
        territory: '30000601',
        countryCode: '230',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        tier: mxp_schemas_1.Checkout.Tiers.TIER3,
        region: 'Africa',
    },
    {
        key: 'YT',
        text: 'Mayotte',
        value: 'YT',
        countryCode: '262',
        ISOAlpha3Code: 'MYT',
        territory: '40000611',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_13,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_13,
        region: 'Africa',
    },
    {
        key: 'MX',
        text: 'Mexico',
        value: 'MX',
        ISOAlpha3Code: 'MEX',
        territory: '70000003',
        countryCode: '52',
        isAmerica: true,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'America',
    },
    {
        key: 'FM',
        text: 'Micronesia, Federated States of',
        value: 'FM',
        countryCode: '691',
        ISOAlpha3Code: 'FSM',
        territory: '70000001',
        isUsTerritory: true,
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_US_TERRITORIES_1,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_US_TERRITORIES_1,
        region: 'APAC',
        isAmerica: true,
    },
    {
        key: 'MD',
        text: 'Moldova, Republic of',
        value: 'MD',
        ISOAlpha3Code: 'MDA',
        territory: '20000229',
        countryCode: '373',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_11,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_11,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'Europe',
    },
    {
        key: 'MC',
        text: 'Monaco',
        value: 'MC',
        countryCode: '377',
        ISOAlpha3Code: 'MCO',
        territory: '20000230',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_7,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_7,
        tier: mxp_schemas_1.Checkout.Tiers.TIER1,
        region: 'Europe',
    },
    {
        key: 'MN',
        text: 'Mongolia',
        value: 'MN',
        ISOAlpha3Code: 'MNG',
        territory: '60040002',
        countryCode: '976',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_8,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_8,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
    },
    {
        key: 'ME',
        text: 'Montenegro',
        value: 'ME',
        ISOAlpha3Code: 'MNE',
        countryCode: '382',
        territory: '20000231',
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'Europe',
    },
    {
        key: 'MS',
        text: 'Montserrat',
        value: 'MS',
        countryCode: '1-664',
        ISOAlpha3Code: 'MSR',
        territory: '70000066',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_13,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_13,
        region: 'America',
        isAmerica: true,
    },
    {
        key: 'MA',
        text: 'Morocco',
        value: 'MA',
        ISOAlpha3Code: 'MAR',
        territory: '30001301',
        countryCode: '212',
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'Africa',
    },
    {
        key: 'MZ',
        text: 'Mozambique',
        value: 'MZ',
        ISOAlpha3Code: 'MOZ',
        territory: '30001332',
        countryCode: '258',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_8,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_8,
        tier: mxp_schemas_1.Checkout.Tiers.TIER3,
        region: 'Africa',
    },
    {
        key: 'MM',
        text: 'Myanmar',
        value: 'MM',
        countryCode: '95',
        ISOAlpha3Code: 'MMR',
        territory: '50000003',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_CIMA_VERY_HIGH_RISK_B2C,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
    },
    {
        key: 'NA',
        text: 'Namibia',
        value: 'NA',
        ISOAlpha3Code: 'NAM',
        territory: '30000701',
        countryCode: '264',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        tier: mxp_schemas_1.Checkout.Tiers.TIER3,
        region: 'Africa',
    },
    {
        key: 'NR',
        text: 'Nauru',
        value: 'NR',
        countryCode: '674',
        ISOAlpha3Code: 'NRU',
        territory: '50000021',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_14,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_14,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
    },
    {
        key: 'NP',
        text: 'Nepal',
        value: 'NP',
        ISOAlpha3Code: 'NPL',
        territory: '40000202',
        countryCode: '977',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
    },
    {
        key: 'NL',
        text: 'Netherlands',
        value: 'NL',
        ISOAlpha3Code: 'NLD',
        territory: '20000232',
        countryCode: '31',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        tier: mxp_schemas_1.Checkout.Tiers.TIER1,
        region: 'Europe',
    },
    {
        key: 'NC',
        text: 'New Caledonia',
        value: 'NC',
        countryCode: '687',
        ISOAlpha3Code: 'NCL',
        territory: '50003003',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_14,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_14,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
    },
    {
        key: 'NZ',
        text: 'New Zealand',
        value: 'NZ',
        ISOAlpha3Code: 'NZL',
        territory: '50000201',
        countryCode: '64',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        tier: mxp_schemas_1.Checkout.Tiers.TIER1,
        region: 'APAC',
    },
    {
        key: 'NI',
        text: 'Nicaragua',
        value: 'NI',
        countryCode: '505',
        ISOAlpha3Code: 'NIC',
        territory: '70000038',
        minPrecision: mxp_schemas_1.SmartyStreets.PrecisionLevel.LOCALITY,
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_AICPA_VERY_HIGH_RISK_B2C,
        isAmerica: true,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'America',
    },
    {
        key: 'NE',
        text: 'Niger',
        value: 'NE',
        ISOAlpha3Code: 'NER',
        territory: '30001333',
        countryCode: '227',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_11,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_11,
        tier: mxp_schemas_1.Checkout.Tiers.TIER3,
        region: 'Africa',
    },
    {
        key: 'NG',
        text: 'Nigeria',
        value: 'NG',
        ISOAlpha3Code: 'NGA',
        territory: '30000801',
        countryCode: '234',
        tier: mxp_schemas_1.Checkout.Tiers.TIER3,
        region: 'Africa',
    },
    {
        key: 'NU',
        text: 'Niue',
        value: 'NU',
        countryCode: '683',
        ISOAlpha3Code: 'NIU',
        territory: '50003004',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_14,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_14,
        region: 'APAC',
    },
    {
        key: 'NF',
        text: 'Norfolk Island',
        value: 'NF',
        countryCode: '672',
        ISOAlpha3Code: 'NFK',
        territory: '50003005',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_13,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_13,
        region: 'APAC',
    },
    {
        key: 'MP',
        text: 'Northern Mariana Islands',
        value: 'MP',
        countryCode: '1-670',
        ISOAlpha3Code: 'MNP',
        territory: '70000001',
        isUsTerritory: true,
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_US_TERRITORIES_1,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_US_TERRITORIES_1,
        region: 'APAC',
        isAmerica: true,
    },
    {
        key: 'NO',
        text: 'Norway',
        value: 'NO',
        countryCode: '47',
        ISOAlpha3Code: 'NOR',
        territory: '20000233',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_4,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_4,
        tier: mxp_schemas_1.Checkout.Tiers.TIER1,
        region: 'Europe',
    },
    {
        key: 'OM',
        text: 'Oman',
        value: 'OM',
        ISOAlpha3Code: 'OMN',
        territory: '40000403',
        countryCode: '968',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
    },
    {
        key: 'PK',
        text: 'Pakistan',
        value: 'PK',
        ISOAlpha3Code: 'PAK',
        territory: '40000501',
        countryCode: '92',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_PART_2_ADDITIONAL_COUNTRIES,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_PART_2_ADDITIONAL_COUNTRIES,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
    },
    {
        key: 'PW',
        text: 'Palau',
        value: 'PW',
        countryCode: '680',
        ISOAlpha3Code: 'PLW',
        territory: '50000026',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_16,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_16,
    },
    {
        key: 'PS',
        text: 'Palestinian Territory',
        value: 'PS',
        countryCode: '970',
        ISOAlpha3Code: 'PSE',
        territory: '40000219',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_3,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_3,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
    },
    {
        key: 'PA',
        text: 'Panama',
        value: 'PA',
        countryCode: '507',
        isAmerica: true,
        ISOAlpha3Code: 'PAN',
        territory: '70000039',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_10,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_10,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'America',
    },
    {
        key: 'PG',
        text: 'Papua New Guinea',
        value: 'PG',
        countryCode: '675',
        ISOAlpha3Code: 'PNG',
        territory: '50000027',
        minPrecision: mxp_schemas_1.SmartyStreets.PrecisionLevel.LOCALITY,
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_7,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_7,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
    },
    {
        key: 'PY',
        text: 'Paraguay',
        value: 'PY',
        countryCode: '595',
        ISOAlpha3Code: 'PRY',
        territory: '70000040',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_13,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_13,
        isAmerica: true,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'America',
    },
    {
        key: 'PE',
        text: 'Peru',
        value: 'PE',
        countryCode: '51',
        ISOAlpha3Code: 'PER',
        territory: '70000041',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_4,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_4,
        isAmerica: true,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'America',
    },
    {
        key: 'PH',
        text: 'Philippines',
        value: 'PH',
        ISOAlpha3Code: 'PHL',
        territory: '50000004',
        countryCode: '63',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
    },
    {
        key: 'PN',
        text: 'Pitcairn Islands',
        value: 'PN',
        countryCode: '64',
        ISOAlpha3Code: 'PCN',
        territory: '50003007',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_14,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_14,
        region: 'APAC',
    },
    {
        key: 'PL',
        text: 'Poland',
        value: 'PL',
        ISOAlpha3Code: 'POL',
        territory: '20000502',
        countryCode: '48',
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'Europe',
    },
    {
        key: 'PT',
        text: 'Portugal',
        value: 'PT',
        ISOAlpha3Code: 'PRT',
        territory: '20000234',
        countryCode: '351',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_2,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_2,
        tier: mxp_schemas_1.Checkout.Tiers.TIER1,
        region: 'Europe',
    },
    {
        key: 'PR',
        text: 'Puerto Rico',
        value: 'PR',
        countryCode: '1-787',
        ISOAlpha3Code: 'PRI',
        territory: '70000001',
        isUsTerritory: true,
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_US_TERRITORIES_1,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_US_TERRITORIES_1,
        tier: mxp_schemas_1.Checkout.Tiers.TIER1,
        region: 'America',
        isAmerica: true,
    },
    {
        key: 'QA',
        text: 'Qatar',
        value: 'QA',
        ISOAlpha3Code: 'QAT',
        territory: '40000404',
        countryCode: '974',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
    },
    {
        key: 'RE',
        text: 'Reunion',
        value: 'RE',
        ISOAlpha3Code: 'REU',
        territory: '30001349',
        countryCode: '262',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_11,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_11,
        tier: mxp_schemas_1.Checkout.Tiers.TIER3,
        region: 'Africa',
    },
    {
        key: 'RO',
        text: 'Romania',
        value: 'RO',
        ISOAlpha3Code: 'ROU',
        territory: '20000508',
        countryCode: '40',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'Europe',
    },
    {
        key: 'RW',
        text: 'Rwanda',
        value: 'RW',
        ISOAlpha3Code: 'RWA',
        territory: '30001335',
        countryCode: '250',
        tier: mxp_schemas_1.Checkout.Tiers.TIER3,
        region: 'Africa',
    },
    {
        key: 'BL',
        text: 'Saint Barthelemy',
        altNames: ['Saint Barthélemy'],
        value: 'BL',
        countryCode: '590',
        ISOAlpha3Code: 'BLM',
        territory: '70000067',
        validateZipCode: false,
        minPrecision: mxp_schemas_1.SmartyStreets.PrecisionLevel.NONE,
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_15,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_15,
        region: 'Europe',
    },
    {
        key: 'SH',
        text: 'Saint Helena',
        value: 'SH',
        countryCode: '290',
        ISOAlpha3Code: 'SHN',
        territory: '30001350',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_14,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_14,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
        isAmerica: true,
    },
    {
        key: 'KN',
        text: 'Saint Kitts and Nevis',
        value: 'KN',
        countryCode: '1-869',
        ISOAlpha3Code: 'KNA',
        territory: '70000044',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_3,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_3,
        isAmerica: true,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'America',
    },
    {
        key: 'LC',
        text: 'Saint Lucia',
        value: 'LC',
        countryCode: '1-758',
        ISOAlpha3Code: 'LCA',
        territory: '70000045',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_4,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_4,
        minPrecision: mxp_schemas_1.SmartyStreets.PrecisionLevel.LOCALITY,
        isAmerica: true,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'America',
    },
    {
        key: 'MF',
        text: 'Saint Martin (French part)',
        value: 'MF',
        countryCode: '590',
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        ISOAlpha3Code: 'MAF',
        territory: '70000068',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_14,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_14,
        region: 'Europe',
        isAmerica: true,
    },
    {
        key: 'PM',
        text: 'Saint Pierre and Miquelon',
        value: 'PM',
        countryCode: '508',
        ISOAlpha3Code: 'SPM',
        territory: '70000069',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_13,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_13,
        region: 'Europe',
    },
    {
        key: 'VC',
        text: 'Saint Vincent and the Grenadines',
        value: 'VC',
        countryCode: '1-784',
        ISOAlpha3Code: 'VCT',
        territory: '70000048',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_7,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_7,
        isAmerica: true,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'America',
    },
    {
        key: 'WS',
        text: 'Samoa, the Independent State of',
        altNames: ['Samoa (Independent)'],
        value: 'WS',
        countryCode: '685',
        ISOAlpha3Code: 'WSM',
        territory: '50000029',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_14,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_14,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
    },
    {
        key: 'SM',
        text: 'San Marino',
        value: 'SM',
        countryCode: '378',
        ISOAlpha3Code: 'SMR',
        territory: '20000235',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_13,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_13,
        region: 'Europe',
    },
    {
        key: 'ST',
        text: 'Sao Tome and Principe',
        value: 'ST',
        countryCode: '239',
        ISOAlpha3Code: 'STP',
        territory: '30001337',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_13,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_13,
        tier: mxp_schemas_1.Checkout.Tiers.TIER3,
        region: 'Africa',
    },
    {
        key: 'SA',
        text: 'Saudi Arabia',
        value: 'SA',
        ISOAlpha3Code: 'SAU',
        territory: '40000405',
        countryCode: '966',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
    },
    {
        key: 'SN',
        text: 'Senegal',
        value: 'SN',
        countryCode: '221',
        ISOAlpha3Code: 'SEN',
        territory: '30001338',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_10,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_10,
        tier: mxp_schemas_1.Checkout.Tiers.TIER3,
        region: 'Africa',
    },
    {
        key: 'RS',
        text: 'Serbia',
        value: 'RS',
        countryCode: '381',
        ISOAlpha3Code: 'SRB',
        territory: '20000236',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_AICPA_VERY_HIGH_RISK_APPROVED_B2C,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'Europe',
    },
    {
        key: 'SC',
        text: 'Seychelles',
        value: 'SC',
        countryCode: '248',
        ISOAlpha3Code: 'SYC',
        territory: '30001339',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_14,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_14,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'Africa',
    },
    {
        key: 'SL',
        text: 'Sierra Leone',
        value: 'SL',
        ISOAlpha3Code: 'SLE',
        territory: '30001340',
        countryCode: '232',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_8,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_8,
        tier: mxp_schemas_1.Checkout.Tiers.TIER3,
        region: 'Africa',
    },
    {
        key: 'SG',
        text: 'Singapore',
        value: 'SG',
        ISOAlpha3Code: 'SGP',
        territory: '50000005',
        countryCode: '65',
        tier: mxp_schemas_1.Checkout.Tiers.TIER1,
        region: 'APAC',
    },
    {
        key: 'SX',
        text: 'Sint Maarten',
        value: 'SX',
        countryCode: '1-721',
        ISOAlpha3Code: 'SXM',
        territory: '20000238',
        minPrecision: mxp_schemas_1.SmartyStreets.PrecisionLevel.LOCALITY,
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_7,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_7,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'America',
        isAmerica: true,
    },
    {
        key: 'SK',
        text: 'Slovakia',
        value: 'SK',
        ISOAlpha3Code: 'SVK',
        territory: '20000509',
        countryCode: '421',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        tier: mxp_schemas_1.Checkout.Tiers.TIER1,
        region: 'Europe',
    },
    {
        key: 'SI',
        text: 'Slovenia',
        value: 'SI',
        countryCode: '386',
        ISOAlpha3Code: 'SVN',
        territory: '20000510',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_4,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_4,
        tier: mxp_schemas_1.Checkout.Tiers.TIER1,
        region: 'Europe',
    },
    {
        key: 'SB',
        text: 'Solomon Islands',
        value: 'SB',
        countryCode: '677',
        ISOAlpha3Code: 'SLB',
        territory: '50000030',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_13,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_13,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
    },
    {
        key: 'SO',
        text: 'Somalia',
        value: 'SO',
        countryCode: '252',
        ISOAlpha3Code: 'SOM',
        territory: '30001341',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_CIMA_VERY_HIGH_RISK_B2C,
        isRestricted: true,
        tier: mxp_schemas_1.Checkout.Tiers.RESTRICTED,
        region: 'Africa',
    },
    {
        key: 'ZA',
        text: 'South Africa',
        value: 'ZA',
        ISOAlpha3Code: 'ZAF',
        territory: '30001501',
        countryCode: '27',
        tier: mxp_schemas_1.Checkout.Tiers.TIER3,
        region: 'Africa',
    },
    {
        key: 'GS',
        text: 'South Georgia and the South Sandwich Islands',
        value: 'GS',
        ISOAlpha3Code: 'SGS',
        countryCode: '500',
        territory: '70000062',
        region: 'America',
    },
    {
        key: 'SS',
        text: 'South Sudan',
        value: 'SS',
        ISOAlpha3Code: 'SSD',
        countryCode: '211',
        territory: '30001342',
        isRestricted: true,
        tier: mxp_schemas_1.Checkout.Tiers.RESTRICTED,
        region: 'Africa',
    },
    {
        key: 'ES',
        text: 'Spain',
        value: 'ES',
        ISOAlpha3Code: 'ESP',
        territory: '20000237',
        countryCode: '34',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        tier: mxp_schemas_1.Checkout.Tiers.TIER1,
        region: 'Europe',
    },
    {
        key: 'LK',
        text: 'Sri Lanka',
        value: 'LK',
        ISOAlpha3Code: 'LKA',
        territory: '40000601',
        countryCode: '94',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
    },
    {
        key: 'SD',
        text: 'Sudan',
        value: 'SD',
        countryCode: '249',
        ISOAlpha3Code: 'SDN',
        territory: '30001343',
        minPrecision: mxp_schemas_1.SmartyStreets.PrecisionLevel.LOCALITY,
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_AICPA_VERY_HIGH_RISK_B2C,
        isRestricted: true,
        tier: mxp_schemas_1.Checkout.Tiers.RESTRICTED,
        region: 'Africa',
    },
    {
        key: 'SR',
        text: 'Suriname',
        value: 'SR',
        ISOAlpha3Code: 'SUR',
        territory: '70000051',
        countryCode: '597',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_2,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_2,
        isAmerica: true,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'America',
    },
    {
        key: 'SJ',
        text: 'Svalbard and Jan Mayen Islands',
        value: 'SJ',
        countryCode: '47',
        ISOAlpha3Code: 'SJM',
        territory: '20000628',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_13,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_13,
        region: 'Europe',
    },
    {
        key: 'SE',
        text: 'Sweden',
        value: 'SE',
        ISOAlpha3Code: 'SWE',
        territory: '20000239',
        countryCode: '46',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_2,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_2,
        tier: mxp_schemas_1.Checkout.Tiers.TIER1,
        region: 'Europe',
    },
    {
        key: 'CH',
        text: 'Switzerland',
        value: 'CH',
        ISOAlpha3Code: 'CHE',
        territory: '20000240',
        countryCode: '41',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        tier: mxp_schemas_1.Checkout.Tiers.TIER1,
        region: 'Europe',
    },
    {
        key: 'TW',
        text: 'Taiwan, China',
        altNames: ['Taiwan Area', 'Taiwan'],
        value: 'TW',
        ISOAlpha3Code: 'TWN',
        territory: '60040004',
        countryCode: '886',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
    },
    {
        key: 'TJ',
        text: 'Tajikistan',
        value: 'TJ',
        countryCode: '992',
        ISOAlpha3Code: 'TJK',
        territory: '20000241',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_13,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_13,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
    },
    {
        key: 'TZ',
        text: 'Tanzania',
        altNames: ['Tanzania, United Republic of'],
        value: 'TZ',
        countryCode: '255',
        ISOAlpha3Code: 'TZA',
        territory: '30000901',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_6,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_6,
        tier: mxp_schemas_1.Checkout.Tiers.TIER3,
        region: 'Africa',
    },
    {
        key: 'TH',
        text: 'Thailand',
        value: 'TH',
        ISOAlpha3Code: 'THA',
        territory: '50000007',
        countryCode: '66',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
    },
    {
        key: 'TL',
        text: 'Timor-Leste',
        value: 'TL',
        countryCode: '670',
        ISOAlpha3Code: 'TLS',
        territory: '50000031',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_13,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_13,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
    },
    {
        key: 'TG',
        text: 'Togo',
        value: 'TG',
        countryCode: '228',
        ISOAlpha3Code: 'TGO',
        territory: '30001345',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_14,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_14,
        tier: mxp_schemas_1.Checkout.Tiers.TIER3,
        region: 'Africa',
    },
    {
        key: 'TK',
        text: 'Tokelau',
        value: 'TK',
        countryCode: '690',
        ISOAlpha3Code: 'TKL',
        territory: '50003011',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_13,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_13,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
    },
    {
        key: 'TO',
        text: 'Tonga',
        value: 'TO',
        countryCode: '676',
        ISOAlpha3Code: 'TON',
        territory: '50000033',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_13,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_13,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
    },
    {
        key: 'TT',
        text: 'Trinidad and Tobago',
        value: 'TT',
        ISOAlpha3Code: 'TTO',
        territory: '70000003',
        countryCode: '1-868',
        isAmerica: true,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'America',
    },
    {
        key: 'TN',
        text: 'Tunisia',
        value: 'TN',
        ISOAlpha3Code: 'TUN',
        territory: '30001301',
        countryCode: '216',
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'Africa',
    },
    {
        key: 'TR',
        text: 'Turkey',
        value: 'TR',
        ISOAlpha3Code: 'TUR',
        territory: '20000242',
        countryCode: '90',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'Europe',
    },
    {
        key: 'TM',
        text: 'Turkmenistan',
        value: 'TM',
        ISOAlpha3Code: 'TKM',
        countryCode: '993',
        territory: '20000243',
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
    },
    {
        key: 'TC',
        text: 'Turks and Caicos Islands',
        value: 'TC',
        countryCode: '1-649',
        ISOAlpha3Code: 'TCA',
        territory: '20000624',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_6,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_6,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'America',
        isAmerica: true,
    },
    {
        key: 'TV',
        text: 'Tuvalu',
        value: 'TV',
        countryCode: '688',
        ISOAlpha3Code: 'TUV',
        territory: '50000034',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_13,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_13,
        region: 'APAC',
    },
    {
        key: 'UG',
        text: 'Uganda',
        value: 'UG',
        countryCode: '256',
        ISOAlpha3Code: 'UGA',
        territory: '30001001',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_14,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_14,
        tier: mxp_schemas_1.Checkout.Tiers.TIER3,
        region: 'Africa',
    },
    {
        key: 'UA',
        text: 'Ukraine',
        value: 'UA',
        ISOAlpha3Code: 'UKR',
        territory: '20000503',
        countryCode: '380',
        minPrecision: mxp_schemas_1.SmartyStreets.PrecisionLevel.LOCALITY,
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_UKRAINE,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_UKRAINE,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'Europe',
    },
    {
        key: 'AE',
        text: 'United Arab Emirates',
        value: 'AE',
        ISOAlpha3Code: 'ARE',
        territory: '40000406',
        countryCode: '971',
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
    },
    {
        key: 'UM',
        text: 'United States Minor Outlying Islands',
        ISOAlpha3Code: 'UMI',
        value: 'UM',
        countryCode: '246',
        region: 'APAC',
    },
    {
        key: 'UY',
        text: 'Uruguay',
        value: 'UY',
        countryCode: '598',
        ISOAlpha3Code: 'URY',
        territory: '70000054',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_7,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_7,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        isAmerica: true,
        region: 'America',
    },
    {
        key: 'UZ',
        text: 'Uzbekistan',
        value: 'UZ',
        countryCode: '998',
        ISOAlpha3Code: 'UZB',
        territory: '20000244',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_9,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_9,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
    },
    {
        key: 'VU',
        text: 'Vanuatu',
        value: 'VU',
        countryCode: '678',
        ISOAlpha3Code: 'VUT',
        territory: '50000035',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_12,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_12,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
    },
    {
        key: 'VA',
        text: 'Vatican City State (Holy See)',
        value: 'VA',
        ISOAlpha3Code: 'VAT',
        countryCode: '379',
        region: 'Europe',
    },
    {
        key: 'VN',
        text: 'Vietnam',
        value: 'VN',
        ISOAlpha3Code: 'VNM',
        territory: '50000006',
        countryCode: '84',
        allowAliasChange: true,
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
    },
    {
        key: 'VG',
        text: 'Virgin Islands (British)',
        value: 'VG',
        countryCode: '1',
        ISOAlpha3Code: 'VGB',
        territory: '70000061',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_9,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_9,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'America',
        isAmerica: true,
    },
    {
        key: 'VI',
        text: 'Virgin Islands (U.S.)',
        value: 'VI',
        countryCode: '1',
        ISOAlpha3Code: 'VIR',
        territory: '70000001',
        isUsTerritory: true,
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_US_TERRITORIES_1,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_US_TERRITORIES_1,
        tier: mxp_schemas_1.Checkout.Tiers.TIER1,
        region: 'America',
        isAmerica: true,
    },
    {
        key: 'WF',
        text: 'Wallis and Futuna',
        value: 'WF',
        countryCode: '681',
        ISOAlpha3Code: 'WLF',
        territory: '50003006',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_14,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_14,
        region: 'APAC',
    },
    {
        key: 'EH',
        text: 'Western Sahara',
        value: 'EH',
        countryCode: '212',
        ISOAlpha3Code: 'ESH',
        territory: '40000612',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_14,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_14,
        region: 'Africa',
    },
    {
        key: 'YE',
        text: 'Yemen',
        value: 'YE',
        countryCode: '967',
        ISOAlpha3Code: 'YEM',
        territory: '40000222',
        minPrecision: mxp_schemas_1.SmartyStreets.PrecisionLevel.LOCALITY,
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_AICPA_VERY_HIGH_RISK_B2C,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
    },
    {
        key: 'ZM',
        text: 'Zambia',
        value: 'ZM',
        ISOAlpha3Code: 'ZMB',
        territory: '30001101',
        countryCode: '260',
        minPrecision: mxp_schemas_1.SmartyStreets.PrecisionLevel.LOCALITY,
        tier: mxp_schemas_1.Checkout.Tiers.TIER3,
        region: 'Africa',
    },
    {
        key: 'ZW',
        text: 'Zimbabwe',
        value: 'ZW',
        ISOAlpha3Code: 'ZWE',
        territory: '30001201',
        countryCode: '263',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_PART_2_ADDITIONAL_COUNTRIES,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_PART_2_ADDITIONAL_COUNTRIES,
        tier: mxp_schemas_1.Checkout.Tiers.TIER3,
        region: 'Africa',
    },
];
exports.CheckoutCountriesListHash = exports.COUNTRIES_LIST.reduce((acc, country) => {
    if (country.ISOAlpha3Code)
        acc[country.ISOAlpha3Code] = country;
    return acc;
}, {});
/**
 * Temp Fix: Transform Kosovo country codes (XKX, XKV) to XK in suggestions.
 * This ensures Vertex & Zuora recognizes the address as Kosovo until it gets resolved by SmartyStreets.
 * ticket number to revisit: BAU-2435
 */
exports.kosovoCodesToTransform = ['XKX', 'XKV'];
const normalizeKosovoCountry = (country) => {
    if (exports.kosovoCodesToTransform.includes(country) || country.toLowerCase().includes('kosovo')) {
        return 'XK';
    }
    return country;
};
exports.normalizeKosovoCountry = normalizeKosovoCountry;
exports.countriesWithStates = [
    'AUS',
    'BRA',
    'DEU',
    'IND',
    'MYS',
    'MEX',
    'MMR',
    'NZL',
    'NGA',
    'PLW',
    'USA',
];
const CheckoutCountriesFilteredListHash = () => {
    const filteredList = exports.COUNTRIES_LIST.reduce((acc, country) => {
        if (country.ISOAlpha3Code) {
            acc[country.ISOAlpha3Code] = country;
        }
        return acc;
    }, {});
    return filteredList;
};
exports.CheckoutCountriesFilteredListHash = CheckoutCountriesFilteredListHash;
exports.CheckoutCountriesTextToISOAlpha3CodeMap = Object.values(exports.CheckoutCountriesListHash).reduce((acc, country) => {
    acc[country.text] = country.ISOAlpha3Code;
    return acc;
}, {});
const CheckoutCountriesTextToISOAlpha3CodeMapCI = Object.values(exports.CheckoutCountriesListHash).reduce((acc, country) => {
    acc[country.text.toLowerCase()] = country.ISOAlpha3Code;
    return acc;
}, {});
const CheckoutCountriesISOAlpha2ToISOAlpha3CodeMap = exports.COUNTRIES_LIST.reduce((acc, country) => {
    if (country.value && country.ISOAlpha3Code) {
        acc[country.value] = country.ISOAlpha3Code;
    }
    return acc;
}, {});
const CheckoutCountriesAltNamesToISOAlpha3CodeMap = exports.COUNTRIES_LIST.reduce((acc, country) => {
    const isoAlpha3Code = country.ISOAlpha3Code;
    if (country.altNames && isoAlpha3Code) {
        country.altNames.forEach((altName) => {
            acc[altName.toLowerCase()] = isoAlpha3Code;
        });
    }
    return acc;
}, {});
const resolveCountryNamesToISOAlpha3CodeWithFallbacks = (countryText, log) => {
    var _a, _b;
    if (!countryText) {
        (_a = log === null || log === void 0 ? void 0 : log.error) === null || _a === void 0 ? void 0 : _a.call(log, 'Country text is empty or undefined.');
        return null;
    }
    // Check if the input is already an ISO Alpha-3 code
    if (exports.CheckoutCountriesListHash[countryText.toUpperCase()]) {
        return countryText.toUpperCase();
    }
    const resolvedCountryISOAlpha3Code = CheckoutCountriesTextToISOAlpha3CodeMapCI[countryText.toLowerCase()] ||
        CheckoutCountriesISOAlpha2ToISOAlpha3CodeMap[countryText.toUpperCase()] ||
        CheckoutCountriesAltNamesToISOAlpha3CodeMap[countryText.toLowerCase()] ||
        null;
    if (!resolvedCountryISOAlpha3Code) {
        (_b = log === null || log === void 0 ? void 0 : log.error) === null || _b === void 0 ? void 0 : _b.call(log, `Input: "${countryText}" could not be resolved to an ISO Alpha-3 code.`);
    }
    return resolvedCountryISOAlpha3Code;
};
exports.resolveCountryNamesToISOAlpha3CodeWithFallbacks = resolveCountryNamesToISOAlpha3CodeWithFallbacks;
const ConvertFromISOAlpha3ToISOAlpha2 = (countryCode) => {
    const selectedCountryISO3 = exports.COUNTRIES_LIST.find(country => countryCode === country.ISOAlpha3Code);
    if (selectedCountryISO3)
        return selectedCountryISO3.value;
    return countryCode;
};
exports.ConvertFromISOAlpha3ToISOAlpha2 = ConvertFromISOAlpha3ToISOAlpha2;
const ConvertFromISOAlpha3ToText = (countryCode) => {
    const selectedCountryText = exports.COUNTRIES_LIST.find(country => countryCode === country.ISOAlpha3Code);
    if (selectedCountryText)
        return selectedCountryText.text;
    return countryCode;
};
exports.ConvertFromISOAlpha3ToText = ConvertFromISOAlpha3ToText;
const ConvertFromISOAlpha2ToISOAlpha3 = (countryCode) => {
    const selectedCountryValue = exports.COUNTRIES_LIST.find(country => countryCode === country.value);
    if (selectedCountryValue)
        return selectedCountryValue.ISOAlpha3Code;
    return countryCode;
};
exports.ConvertFromISOAlpha2ToISOAlpha3 = ConvertFromISOAlpha2ToISOAlpha3;
const ConvertFromISOAlpha2ToText = (countryCode) => {
    const selectedCountryValue = exports.COUNTRIES_LIST.find(country => countryCode === country.value);
    if (selectedCountryValue)
        return selectedCountryValue.text;
    return countryCode;
};
exports.ConvertFromISOAlpha2ToText = ConvertFromISOAlpha2ToText;
const ConvertFromKeyToISOAlpha3 = (countryCode) => {
    const selectedCountryValue = exports.COUNTRIES_LIST.find(country => countryCode === country.key);
    if (selectedCountryValue.ISOAlpha3Code)
        return selectedCountryValue.ISOAlpha3Code;
    return countryCode;
};
exports.ConvertFromKeyToISOAlpha3 = ConvertFromKeyToISOAlpha3;
const ConvertFromTextToISOAlpha3 = (countryText) => {
    const selectedCountryValue = exports.COUNTRIES_LIST.find(country => countryText.toLowerCase() === country.text.toLowerCase());
    if (!selectedCountryValue)
        return countryText;
    return selectedCountryValue.ISOAlpha3Code;
};
exports.ConvertFromTextToISOAlpha3 = ConvertFromTextToISOAlpha3;
// Returns null if no country found unlike ConvertFromTextToISOAlpha3 which returns the input text
const ConvertFromCountryTextToISOAlpha3 = (countryText) => {
    const selectedCountryValue = exports.COUNTRIES_LIST.find(country => countryText.toLowerCase() === country.text.toLowerCase());
    if (selectedCountryValue)
        return selectedCountryValue.ISOAlpha3Code;
    return null;
};
exports.ConvertFromCountryTextToISOAlpha3 = ConvertFromCountryTextToISOAlpha3;
const ConvertFromISOToCountryCodeText = (key) => {
    const selectedCountryValue = exports.COUNTRIES_LIST.find(country => key === country.key);
    if (selectedCountryValue)
        return selectedCountryValue.countryCode;
    return key;
};
exports.ConvertFromISOToCountryCodeText = ConvertFromISOToCountryCodeText;
const convertToIsoAlpha2 = (key) => {
    // From Country Text or ISO-Alpha3 to ISO-Alpha2
    const country = exports.COUNTRIES_LIST.find(c => c.text.toLowerCase() === key.toLowerCase() || c.ISOAlpha3Code === key);
    if (country)
        return country.value;
    return 'UNDEFINED';
};
exports.convertToIsoAlpha2 = convertToIsoAlpha2;
exports.AllUSRegions = [
    exports.CheckoutCountriesListHash.USA.ISOAlpha3Code, // USA
    exports.CheckoutCountriesListHash.PRI.ISOAlpha3Code, // Puerto Rico
    exports.CheckoutCountriesListHash.GUM.ISOAlpha3Code, // Guam
    exports.CheckoutCountriesListHash.VIR.ISOAlpha3Code, // Virgin Islands (US)
    exports.CheckoutCountriesListHash.MNP.ISOAlpha3Code, // Mariana Islands
    exports.CheckoutCountriesListHash.ASM.ISOAlpha3Code, // American Samoa
];
const checkQualificationStatus = (hasMembershipProduct, isCimaApplicationType, isUserCpaLicensed, learningPathway, isApprenticeLapsedOrSuspendedRenewal, enrollmentStatus) => {
    const isEligible = hasMembershipProduct && (isCimaApplicationType || isUserCpaLicensed);
    // change Not Applicable status to Pending Progression engine run
    if ([mxp_schemas_1.MembershipTypes.Pathway.APPRENTICE_L4, mxp_schemas_1.MembershipTypes.Pathway.APPRENTICE_L7].includes(learningPathway) &&
        isApprenticeLapsedOrSuspendedRenewal &&
        enrollmentStatus === mxp_schemas_1.Salesforce.CimaStatus.ENROLLED) {
        return mxp_schemas_1.User.QualificationLevelStatus.PendingProgressionEngineRun;
    }
    return isEligible ? user_1.PersonQualificationLevelItems[learningPathway] : '';
};
exports.checkQualificationStatus = checkQualificationStatus;
const checkIfAddressIsAmerica = (country) => {
    var _a;
    return (((_a = exports.COUNTRIES_LIST === null || exports.COUNTRIES_LIST === void 0 ? void 0 : exports.COUNTRIES_LIST.find((countryList) => (countryList === null || countryList === void 0 ? void 0 : countryList.ISOAlpha3Code) === country ||
        (countryList === null || countryList === void 0 ? void 0 : countryList.key) === country ||
        (countryList === null || countryList === void 0 ? void 0 : countryList.text) === (0, exports.ConvertFromISOAlpha3ToText)(country))) === null || _a === void 0 ? void 0 : _a.isAmerica) || false);
};
exports.checkIfAddressIsAmerica = checkIfAddressIsAmerica;
/**
 * Validates if a Public Accounting organization has a US address (which is not allowed)
 * @param organizationType - The organization type to check
 * @param addressCountry - The country value from the address
 * @returns boolean - true if it's a Public Accounting org with US address (validation error)
 */
const isPublicAccountingWithUSAddress = (organizationType, addressCountry) => {
    // Use the enum value instead of hardcoded string
    const PUBLIC_ACCOUNTING = mxp_schemas_1.MembershipTypes.OrganizationType.PUBLIC_ACCOUNTING;
    const isPublicAccounting = organizationType === PUBLIC_ACCOUNTING;
    const isUSAddress = addressCountry === exports.CheckoutCountriesListHash.USA.ISOAlpha3Code ||
        addressCountry === exports.CheckoutCountriesListHash.USA.text ||
        addressCountry === exports.CheckoutCountriesListHash.USA.value;
    return isPublicAccounting && isUSAddress;
};
exports.isPublicAccountingWithUSAddress = isPublicAccountingWithUSAddress;
exports.RegionList = [
    { name: 'Africa', key: 'Africa' },
    { name: 'Asia-Pacific', key: 'APAC' },
    { name: 'Americas & Europe', key: 'America' },
    { name: 'North Asia', key: 'North Asia' },
];
//# sourceMappingURL=index.js.map